import { addPaymentMethod, } from '../types'
import HttpService from '../../services/HttpService'

export const addPaymentMethodAction = fields => {
  return async dispatch => {
    
    dispatch({ type: addPaymentMethod.ADD_PAYMENT_METHOD_ERROR, })

    let storage
    try {
      storage = JSON.parse(localStorage.getItem("user-token"))
    } catch (err) {
      return dispatch({ 
        type: addPaymentMethod.ADD_PAYMENT_METHOD_ERROR, 
        payload: message,
      })
    }
    const http = new HttpService()
    const payload = {}
    payload.cardNumber = fields.cardNumber
    payload.expiryDate = fields.expiryDate
    payload.cvv = fields.cvv
    payload.cardHoldersName = fields.cardHoldersName
    await http.postData(
      '/users/'+storage.data.user.id+'/payment-methods',
      payload,
      "user-token",
    )
      .then(res => {
        dispatch({
          type: addPaymentMethod.ADD_PAYMENT_METHOD_SUCCESS,
        })
      })
      .catch(err => {
        let message
        if ("ERR_NETWORK" === err.code) {
          message = "Server unavailable."
        } else if (err.response?.data?.message) {
          message = err.response.data.message
        } else {
          message = "Something went wrong. Please come back later."
        }
        dispatch({ 
          type: addPaymentMethod.ADD_PAYMENT_METHOD_ERROR, 
          payload: message,
        })
      })
  }
}